module.exports = __webpack_public_path__ + "img/image-01.45c4b417.webp";